var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendBackward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "evenodd",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.805 16.934a1.14 1.14 0 0 0 1.13-1.129V1.13A1.14 1.14 0 0 0 15.804 0H1.13A1.14 1.14 0 0 0 0 1.129v14.676a1.14 1.14 0 0 0 1.129 1.13h14.676zm0-1.129H1.13V1.13h14.676v14.676z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 8V4H8v4H4.5l4 4 4-4z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.867 6.933a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H9.937a1 1 0 0 1-1-1v-6h7.93a1 1 0 0 0 .994-.883l.006-.117v-10h7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendBackward);
export default __webpack_public_path__ + "static/media/send-backward.aa9346c6fb39b77ed82ccb0044faa014.svg";
export { ForwardRef as ReactComponent };